import actionTypes from "_constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_AVITEMS_DATA:
            return {
                ...state,
                getAvItemsData: action.payload,
                getAvItemsDataError: null,
            };
        case actionTypes.GET_AVITEMS_ERROR:
            return {
                ...state,
                getAvItemsDataError: action.payload,
                getAvItemsData: null,
            };
        case actionTypes.GET_ITEMS_DATA:
            return {
                ...state,
                getItemsData: action.payload,
                getItemsDataError: null,
            };
        case actionTypes.GET_ITEMS_ERROR:
            return {
                ...state,
                getItemsDataError: action.payload,
                getItemsData: null,
            };
        case actionTypes.SAVE_NAME_DATA:
            return {
                ...state,
                saveNameData: action.payload,
                saveNameDataError: null,
            };
        case actionTypes.SAVE_NAME_ERROR:
            return {
                ...state,
                saveNameDataError: action.payload,
                saveNameData: null,
            };
        case actionTypes.SAVE_ITEM_DATA:
            return {
                ...state,
                saveItemData: action.payload,
                saveItemDataError: null,
            };
        case actionTypes.SAVE_ITEM_ERROR:
            return {
                ...state,
                saveItemDataError: action.payload,
                saveItemData: null,
            };
        case actionTypes.CLEAR_SAVE_ITEM:
            return {
                ...state,
                saveItemDataError: null,
                saveItemData: null,
            };

        default:
            return state;
    }
};
